import styled from "styled-components";
import image from "../../../assets/vuesax-linear-arrow-right.svg";


export const WalletCardContent = styled.div`
  display: ${(props) => props.display};
  border-radius: 10px;
  background-color: #262626;
  position: fixed;
  width: 400px;
  margin-top: 30px;
  flex-direction:column;
  top: 107px;
  right: 296px;
  z-index:2;
  

`;
export const Page3CardCaption = styled.h3`
  font-size: 20px;
  color: white;
  margin-left: 20px;
  padding: 20px 0px;
  text-align:left;
  line-height:24px;
  font-weight: bold;
`
export const WalletContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom:20px;

  
`;
export const WalletType = styled.a`
  display: flex;
  flex-direction: row;
  background-color: black;
  border-radius: 7px;
  color: white;
  margin-top: 8px;
  margin-left: 20px;
  margin-right: 20px;
  padding: 16px 8px;
  align-items: center;
  max-height: 60px;
  box-sizing: border-box;
  background-image: url(${image});
  background-repeat: no-repeat;
  background-position: 95% 50%;
  background-size: 20px;

`;

export const WalletIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 47px;
  height: 47px;
  background-color: #262626;
  border-radius: 5px;
  margin-right: 10px;
`
